export const PAGINATED_SELECT_TEST_ID = 'paginated-select-test-id';
export const PAGINATED_SELECT_TRIGGER_TEST_ID = 'paginated-select-trigger-test-id';

export const PAGINATED_SELECT_V2_TEST_ID = 'paginated-select-v2-test-id';
export const PAGINATED_SELECT_V2_TRIGGER_TEST_ID = 'paginated-select-v2-trigger-test-id';

export const baseQueryArgs = {
  fetchPolicy: 'cache-and-network' as const,
};
